<div class="wrapper">
  <div class="breadcrumb-container">
    <p-breadcrumb [model]="breadcrumbItems" styleClass="breadcrumb" />
  </div>
  <app-patient-form [type]="type" [prefill]="prefillForm" [patientId]="pid"></app-patient-form>
</div>